import { BusinessObjectBase } from './../../../bo';
import { JoinPointContext, JoinPoint } from './../../../aop';
import { ModelBase } from './../../../model';

export class PropertyChangedJoinPoint extends JoinPoint<PropertyChangedJoinPointContext> { }

export class PropertyChangedJoinPointContext extends JoinPointContext {
    public constructor(
        sender: BusinessObjectBase<ModelBase>,
        public readonly model: ModelBase,
        public readonly propertyName: string,
        public readonly oldValue: any
    ) {
        super(sender);
    }
}
